import connectRefinementList from "instantsearch.js/es/connectors/refinement-list/connectRefinementList.js";
import { useConnector } from "../hooks/useConnector.js";
export function useRefinementList(props, additionalWidgetProperties) {
  return useConnector(connectRefinementList, props, additionalWidgetProperties);
}